import styled from 'styled-components';
import { color3, colorBlack900 } from 'styles';
import { Wrapper as SectionWrapper } from 'components/Subscribe/styles';

export const InfoBlockWrapper = styled(SectionWrapper)`
  padding: 16px;
  margin-top: 16px;
  border: none;
  margin-bottom: 16px;
`;

export const IconWrapper = styled.div`
  margin-right: 10px;
  margin-top: -1px;
  flex-shrink: 0;
`;

export const InfoBlockItem = styled.a`
  display: flex;
  padding: 16px 0;
  font-size: 14px;
  line-height: 20px;
  color: ${colorBlack900};
  transition: opacity 0.3s;

  &:not(:last-of-type) {
    border-bottom: 1px solid ${color3};
  }

  &:hover {
    opacity: 0.8;
  }
`;
